import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/src/userSegRedirectEntrypoint.entrypoint.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { horizontalNavViewEntrypoint } from '@jira/navigation-apps__horizontal-nav-jsm-views/src/horizontalNavViewEntrypoint.entrypoint.tsx';
import { listEntryPoint } from '@jira/spa-apps__servicedesk-list/src/listEntryPoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { ProjectIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/project-app.tsx';
import { listRoute } from '@jira/router-routes__servicedesk-list-routes/src/listRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getCalendarFilterFieldsResource } from '@jira/router-resources__service-desk-calendar/src/useCalendarFilterResource.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { uifBoardResource } from '@jira/router-resources__uif-board/src/uifBoardResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const entryPoint = createPageEntryPoint({
	main: listEntryPoint,
	horizontalNavigation: horizontalNavViewEntrypoint,
	redirect: userSegRedirectEntrypoint,
});

export const listRouteEntry: Route = createEntry(listRoute, () => ({
	group: 'servicedesk',
	// eslint-disable-next-line no-restricted-syntax
	component: ErrorPagesNotFound,
	layout: serviceProjectLayout,

	entryPoint: () => {
		if (!fg('jsm_list_view_milestone_1')) {
			return undefined;
		}
		return entryPoint;
	},

	skeleton: ProjectIssueNavigatorSkeleton,

	navigation: {
		menuId: MenuIdProjects,
	},

	forPaint: [LazyAtlassianNavigation],

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		getCalendarFilterFieldsResource(),
		getConsolidationStateResource(),
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		resourceWithCondition(() => !__SERVER__ && fg('jsm_list_view_milestone_1'), uifBoardResource),
	],

	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
